export function useDateTimeHelper() {
  const yesterdayDateIso = ref(getDaysAgo(1));
  const sevenDaysAgoIso = ref(getDaysAgo(7));
  const thirtyDaysAgoIso = ref(getDaysAgo(30));
  const thirtyOneDaysAgoIso = ref(getDaysAgo(31));

  function getDaysAgo(days: number) {
    const today = new Date();

    today.setHours(today.getHours() - today.getTimezoneOffset() / 60);

    const cntDays = new Date(new Date().setDate(today.getDate() - days));

    cntDays.setHours(cntDays.getHours() - cntDays.getTimezoneOffset() / 60);

    const formattedDate = cntDays.toISOString().split('T')[0];

    return formattedDate;
  }

  function getDateTime(date: string) {
    if (!date) {
      return 'xx/xx/xx xx:xx';
    }

    let newDate;

    newDate = new Date(date);

    if (newDate.toLocaleString() !== 'Invalid Date') {
      return newDate.toLocaleString();
    }

    // filtro para funcionar iphone
    const dateTime =
      date.split(' ').length > 1 ? date.split(' ') : date.split('T');

    const dateArray = dateTime[0]!.split('-');

    newDate =
      dateArray.length === 3
        ? `${dateArray[2]}/${dateArray[1]}/${dateArray[0]} `
        : dateArray.join('-');

    const time = dateTime[1]!.split('.')[0];

    return `${newDate} ${time}`;
  }

  function getFormattedBrazilianDate(date: string) {
    if (!date) {
      return 'xx/xx/xx';
    }

    const [year, month, day] = date.split('-');

    return `${day}/${month}/${year}`;
  }

  function getFormattedDateFromEpoch(epoch: number) {
    if (!epoch) {
      return 'xx/xx/xxxx';
    }

    const date = new Date(epoch);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  return {
    yesterdayDateIso,
    sevenDaysAgoIso,
    thirtyDaysAgoIso,
    thirtyOneDaysAgoIso,
    getDateTime,
    getFormattedBrazilianDate,
    getFormattedDateFromEpoch,
  };
}
